import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerBushingsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-6.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .tbi { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .tbi-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    
  }
  .tbi-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right;
    display: block;
  }
  .tbi-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .tbi-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .tbi-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px;
    max-width: 520px;
  }
  .tbi-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .tbi-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .tbi-breadcrumb {
    width: 100%; padding: 40px 0 0 0;
  }
  .tbi-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto;
    padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .tbi-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none;
    display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .tbi-bc-item:hover { color: #EB2019; }
  .tbi-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .tbi-bc-sep img { width: 24px; height: 24px; display: block; }
  .tbi-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER WRAPPER ══ */
  .tbi-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
  }

  /* ══ MAIN SECTION ══ */
  .tbi-main-section { padding: 80px 0 120px 0; }
  .tbi-main-row {
    display: flex; align-items: flex-start; gap: 89px;
  }

  /* ══ ARTICLE ══ */
  .tbi-article { flex: 1; min-width: 0; }

  /* Meta bar */
  .tbi-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .tbi-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A;
    padding-right: 15px;
  }
  .tbi-meta-item:last-child {
    border-right: none;
    padding-right: 0;
  }
  .tbi-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  /* Article title */
  .tbi-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  /* Article image */
  .tbi-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  /* Body text */
  .tbi-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .tbi-article-body p {
    margin-bottom: 15px;
  }
  .tbi-article-body p:last-child { margin-bottom: 0; }

  /* Bold headings */
  .tbi-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%;
    display: block;
  }

  /* Numbered sub-heading (1. Porcelain Bushings:) */
  .tbi-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 12px 0; line-height: 160%;
    display: block;
  }

  /* Bullet list */
  .tbi-article-body ul {
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .tbi-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .tbi-article-body ul li::before {
    content: '•';
    color: #202020;
    font-size: 16px;
    line-height: 160%;
    flex-shrink: 0;
  }
  .tbi-article-body ul li > span {
    flex: 1;
  }

  .tbi-article-body strong { font-weight: 600; color: #202020; }

  /* ══ BOTTOM ROW ══ */
  .tbi-bottom-row {
    display: flex; align-items: center;
    justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7;
    flex-wrap: wrap; gap: 16px;
  }
  .tbi-bottom-nav {
    display: flex; align-items: center; gap: 30px;
  }
  .tbi-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .tbi-nav-btn:hover { color: #EB2019; }
  .tbi-nav-btn img { width: 40px; height: 40px; display: block; }

  .tbi-share-icons {
    display: flex; align-items: center; gap: 20px;
  }
  .tbi-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .tbi-share-icon:hover { opacity: 0.85; }
  .tbi-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .tbi-sidebar { flex: 0 0 475px; }
  .tbi-sidebar-block { margin-bottom: 60px; }
  .tbi-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }

  /* Recent posts */
  .tbi-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .tbi-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .tbi-recent-item:hover .tbi-recent-title { color: #EB2019; }
  .tbi-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .tbi-recent-body { flex: 1; min-width: 0; }
  .tbi-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }

  /* Social icons */
  .tbi-social-icons { display: flex; align-items: center; gap: 30px; }
  .tbi-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .tbi-social-icon:hover { opacity: 0.8; }
  .tbi-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .tbi-hero             { height: 350px; }
    .tbi-hero-content     { padding: 0 32px; }
    .tbi-hero-title       { font-size: 30px; }
    .tbi-hero-divider     { width: 100%; max-width: 479px; }
    .tbi-breadcrumb       { padding: 24px 0 0 0; }
    .tbi-breadcrumb-inner { padding: 0 32px; }
    .tbi-inner            { padding: 0 32px; }
    .tbi-main-section     { padding: 48px 0 60px 0; }
    .tbi-main-row         { flex-direction: column; gap: 48px; }
    .tbi-sidebar          { flex: none; width: 100%; }
    .tbi-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .tbi-hero             { height: 360px; }
    .tbi-hero-content     { padding: 0 16px; }
    .tbi-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .tbi-hero-divider     { width: 100%; }
    .tbi-hero-subtitle    { font-size: 14px; }
    .tbi-breadcrumb       { padding: 30px 0 0 0; }
    .tbi-breadcrumb-inner { padding: 0 16px; }
    .tbi-bc-item          { font-size: 14px; gap: 14px; }
    .tbi-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .tbi-bc-sep img       { width: 22px; height: 22px; }
    .tbi-inner            { padding: 0 16px; }
    .tbi-main-section     { padding: 30px 0 60px 0; }
    .tbi-main-row         { flex-direction: column; gap: 60px; }
    .tbi-sidebar          { flex: none; width: 100%; }
    .tbi-sidebar-title { font-size: 20px;}
    .tbi-article-title    { font-size: 20px; margin-bottom: 20px; }
    .tbi-article-body     { font-size: 14px; }
    .tbi-meta-item        { font-size: 14px; }
    .tbi-article-img      { margin: 25px 0 30px 0; height: 250px; }
    .tbi-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .tbi-h3               { font-size: 14px; margin: 30px 0 15px 0; }
    .tbi-nav-btn img      { width: 24px; height: 24px; }
    .tbi-nav-btn          { font-size: 14px; }
    .tbi-share-icon img   { width: 34px; height: 34px; }
    .tbi-article-body ul li {font-size: 14px; }
    .tbi-article-body ul  { gap: 8px;}
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-guide/",
  },
];


export default function TransformerBushingsTypesImportance() {
  return (
    <div className="tbi">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="tbi-hero">
        <img className="tbi-hero-bg" src={HeroBgImg} alt="Transformer Bushings Hero" />
        <div className="tbi-hero-overlay" />
        <div className="tbi-hero-content">
          <h1 className="tbi-hero-title">
            Transformer Bushings: Types &amp; Importance
          </h1>
          <hr className="tbi-hero-divider" />
          <p className="tbi-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="tbi-breadcrumb" aria-label="Breadcrumb">
        <div className="tbi-breadcrumb-inner">
          <a href="/" className="tbi-bc-item">Home</a>
          <span className="tbi-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="tbi-bc-item">News &amp; Updates</a>
          <span className="tbi-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="tbi-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="tbi-main-section">
        <div className="tbi-inner">
          <div className="tbi-main-row">

            {/* ── ARTICLE ── */}
            <article className="tbi-article">

              {/* Meta bar */}
              <div className="tbi-meta-bar">
                <span className="tbi-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="tbi-meta-item"><img src={CalendarIcon} alt="date" /> July 1, 2025</span>
                <span className="tbi-meta-item"><img src={ClockIconImg} alt="time" /> 8:27 am</span>
                <span className="tbi-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="tbi-article-title">
                Transformer Bushings: Types &amp; Importance
              </h1>

              {/* Body */}
              <div className="tbi-article-body">

                <p>In the vast and intricate world of electrical power systems, transformers are key players. They ensure electricity is transmitted and distributed efficiently by adjusting voltage levels to make power usable and safe for homes, industries, and commercial establishments. But there's one essential component working quietly behind the scenes—transformer bushings.</p>

                <p>Often overlooked, transformer bushings are vital for the safe flow of electricity. They form the bridge that connects the transformer's internal components with the external electrical system. Without them, reliable power transfer simply wouldn't be possible. Let's delve into what transformer bushings are, why they matter, and how they contribute to the reliable performance of electrical systems.</p>

                <span className="tbi-h2">What is a Transformer Bushing?</span>

                <p>A transformer bushing is a specially designed insulating component that allows a conductor to pass safely through the grounded enclosure of a transformer. Typically cylindrical in shape, these bushings are mounted on the transformer's tank and enable connection between internal windings and external power lines or electrical equipment. In simpler terms, they act as a secure entry and exit point for electrical current, ensuring insulation and preventing electrical faults. Made from high-strength materials like porcelain, epoxy resin, or composites, transformer bushings are built to withstand high voltage and environmental stress.</p>

                {/* Article image */}
                <img className="tbi-article-img" src={ArticleImg} alt="Transformer Bushing" />

                <span className="tbi-h2">Why Transformer Bushings Are So Important</span>

                <p>Transformer bushings play several crucial roles that make them indispensable in power systems:</p>

                <ul>
                  <li><span><strong>Electrical Insulation</strong>: They isolate high voltage from the transformer casing, preventing arcing or dangerous contact.</span></li>
                  <li><span><strong>Voltage Management</strong>: Bushings help manage different voltage levels within a transformer, enabling safe energy transfer.</span></li>
                  <li><span><strong>Mechanical Support</strong>: They support heavy conductors and connections, keeping the transformer stable under load.</span></li>
                  <li><span><strong>Heat Dissipation</strong>: Bushings assist in managing the heat generated during transformer operation.</span></li>
                  <li><span><strong>Environmental Protection</strong>: They act as a barrier against moisture, dust, and contaminants, protecting the transformer's interior.</span></li>
                </ul>

                <span className="tbi-h2">Different Types of Transformer Bushings</span>

                <p>Depending on their material, construction, and application, transformer bushings come in several varieties:</p>

                <span className="tbi-h3">1. Porcelain Bushings :</span>

                <ul>
                  <li><span>Material: High-grade ceramic porcelain</span></li>
                  <li><span>Advantages: Durable, good insulation, cost-effective</span></li>
                  <li><span>Limitations: Heavy and brittle, can crack under stress</span></li>
                  <li><span>Common Use: Traditional and industrial transformers</span></li>
                </ul>

                <span className="tbi-h3">2. Composite Bushings:</span>

                <ul>
                  <li><span>Material: Fiberglass-reinforced core with silicone rubber or epoxy coating</span></li>
                  <li><span>Advantages: Lightweight, weather-resistant, non-brittle</span></li>
                  <li><span>Limitations: Slightly more expensive than porcelain</span></li>
                  <li><span>Common Use: Outdoor substations, polluted or corrosive environments</span></li>
                </ul>

                <span className="tbi-h3">3.  Oil-Filled Bushings:</span>

                <ul>
                  <li><span>Insulation: Filled with mineral oil for insulation and cooling</span></li>
                  <li><span>Advantages: Excellent high-voltage performance</span></li>
                  <li><span>Limitations: Requires regular oil testing and maintenance</span></li>
                  <li><span>Common Use: High-voltage power transformers</span></li>
                </ul>

                <span className="tbi-h3">4.  Resin (Dry-Type) Bushings:</span>

                <ul>
                  <li><span>Material: Solid epoxy or resin insulation</span></li>
                  <li><span>Advantages: No oil, explosion-proof, low maintenance</span></li>
                  <li><span>Limitations: Typically used for indoor or special applications</span></li>
                  <li><span>Common Use: Indoor switchgear, renewable energy systems</span></li>
                </ul>

                <span className="tbi-h2">How to Maintain Transformer Bushings</span>

                <p>Maintaining transformer bushings is key to ensuring long-term performance and avoiding costly failures. Here are essential maintenance practices</p>

                <ul>
                  <li><span>Routine Inspections: Look for visible cracks, surface contamination, or leaks.</span></li>
                  <li><span>Cleaning: Remove dust, moisture, and pollutants that can affect insulation.</span></li>
                  <li><span>Oil Analysis (for oil-filled bushings): Test oil for dielectric strength and contaminants.</span></li>
                  <li><span>Monitoring Systems: Use sensors to track temperature, pressure, and electrical characteristics.</span></li>
                </ul>

                <span className="tbi-h2">Modern Trends in Bushing Technology</span>

                <p>The evolution of electrical infrastructure has driven innovation in bushing technology:</p>

                <ul>
                  <li><span>Smart Bushings: Equipped with sensors for real-time diagnostics</span></li>
                  <li><span>Eco-Friendly Designs: Dry-type and resin bushings replacing oil-filled models</span></li>
                  <li><span>Lightweight Composites: For ease of installation and improved durability</span></li>
                </ul>

                <span className="tbi-h2">Q&amp;A</span>

                <p><strong>Q1: Can transformer bushings be replaced without replacing the whole transformer?</strong></p>
                <p>Yes! Many modern bushings are designed for retrofit, allowing for safer, more efficient upgrades.</p>

                <p><strong>Q2: What happens if a bushing fails?</strong></p>
                <p>Failure can lead to arcing, overheating, or transformer damage. Regular maintenance can prevent most failures.</p>

                <p><strong>Q3: Are composite bushings better than porcelain?</strong></p>
                <p>They offer better durability and resistance in tough environments, but porcelain remains cost-effective for standard use.</p>

                <span className="tbi-h2">Final Thoughts</span>

                <p>Transformer bushings may be small, but their role is massive. By enabling the safe transmission of high voltage through grounded transformer enclosures, they keep our power systems running smoothly. As demand for reliable, sustainable power grows, advanced bushing technologies will continue to shape the future of energy. Whether you're upgrading an aging transformer or designing a new installation, understanding the role of bushings helps ensure safety, efficiency, and reliability. For more expert insights and solutions, trust Ador – your partner in power system innovation.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="tbi-bottom-row">
                <div className="tbi-bottom-nav">
                  <a href="/news/green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups" className="tbi-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/electrostatic-precipitator-market-outlook-2025-2035-trends-forecasts" className="tbi-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="tbi-share-icons">
                  <a href="#" className="tbi-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="tbi-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="tbi-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="tbi-sidebar">

              {/* Recent Posts */}
              <div className="tbi-sidebar-block">
                <p className="tbi-sidebar-title">Recent Posts</p>
                <div className="tbi-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="tbi-recent-item">
                      <img src={post.img} alt={post.title} className="tbi-recent-img" />
                      <div className="tbi-recent-body">
                        <span className="tbi-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="tbi-sidebar-block">
                <p className="tbi-sidebar-title">Social Media</p>
                <div className="tbi-social-icons">
                  <a href="#" className="tbi-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="tbi-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}